import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      await axios.post(`${API_URL}/auth/password-reset/request`, { email });
      setSuccess(true);
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Failed to send password reset email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <img src="/logo-auth.svg" alt="Venue IQ" className="auth-logo" />
        <h2>Reset Your Password</h2>
        {success ? (
          <div className="success-message">
            <p>If an account exists with that email address, we've sent password reset instructions.</p>
            <p>Please check your email and follow the link to reset your password.</p>
            <div className="auth-link" style={{ marginTop: '2rem' }}>
              <Link to="/login">Return to login</Link>
            </div>
          </div>
        ) : (
          <>
            <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '0.95rem' }}>
              Enter your email address and we'll send you instructions to reset your password.
            </p>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <button type="submit" className="btn" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Instructions'}
              </button>
            </form>
            <div className="auth-link">
              <Link to="/login">Back to login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
